import React, { useState, useEffect } from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall';
import { useToast } from '../context/ToastContext';

const PWAInstallPrompt = () => {
  const { supportsPWA, installPWA, isIOS, isStandalone } = usePWAInstall();
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const { showToast } = useToast();

  useEffect(() => {
    if (!isStandalone && (supportsPWA || isIOS)) {
      const dismissed = localStorage.getItem('pwa_prompt_dismissed');
      
      if (dismissed) return;

      const timer = setTimeout(() => {
        setShowInstallPrompt(true);
      }, 2000); // Wait 2s before prompting
      return () => clearTimeout(timer);
    }
  }, [supportsPWA, isIOS, isStandalone]);

  const handleDismiss = () => {
    setShowInstallPrompt(false);
    localStorage.setItem('pwa_prompt_dismissed', 'true');
  };

  if (!showInstallPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 max-w-sm mx-auto bg-surface-container-lowest p-5 rounded-2xl shadow-[0px_10px_40px_rgba(0,0,0,0.2)] border border-primary/20 z-[9999] animate-slide-up" dir="rtl">
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
            <span className="material-symbols-outlined text-primary text-2xl">install_mobile</span>
          </div>
          <div>
            <h3 className="font-headline font-bold text-lg text-on-surface">הוסף למסך הבית</h3>
            <p className="text-sm text-on-surface-variant font-medium">לשמירת מתכונים וגישה מהירה</p>
          </div>
        </div>
        <button onClick={handleDismiss} className="text-on-surface-variant hover:bg-surface-container p-1 rounded-full flex-shrink-0">
          <span className="material-symbols-outlined">close</span>
        </button>
      </div>
      
      {supportsPWA ? (
        <button onClick={async () => {
            await installPWA();
            handleDismiss();
        }} className="w-full py-3 bg-primary text-white font-bold rounded-xl active:scale-95 transition-all outline-none flex justify-center items-center gap-2 text-base">
          התקן אפליקציה 🚀
        </button>
      ) : isIOS ? (
        <div className="text-sm text-on-surface-variant bg-surface-container p-3 rounded-lg flex flex-col gap-2">
          <span className="flex items-center gap-2"><strong className="text-on-surface">1.</strong>לחץ על כפתור<span className="material-symbols-outlined text-lg">more_vert</span></span>
          <span className="flex items-center gap-2"><strong className="text-on-surface">2.</strong> בחר בחלון <strong>"הוסף למסך הבית"</strong> <span className="material-symbols-outlined text-lg">install_desktop</span></span>
        </div>
      ) : null}
    </div>
  );
};

export default PWAInstallPrompt;
